const schemaType = "sanity.previewUrlSecret", schemaIdPrefix = "sanity-preview-url-secret", schemaIdSingleton = `${schemaIdPrefix}.share-access`, schemaTypeSingleton = "sanity.previewUrlShareAccess", apiVersion = "2023-11-09", urlSearchParamPreviewSecret = "sanity-preview-secret", urlSearchParamPreviewPathname = "sanity-preview-pathname", urlSearchParamPreviewPerspective = "sanity-preview-perspective", urlSearchParamVercelProtectionBypass = "x-vercel-protection-bypass", urlSearchParamVercelSetBypassCookie = "x-vercel-set-bypass-cookie", isDev = process.env.NODE_ENV === "development", SECRET_TTL = 60 * 60, fetchSecretQuery = (
  /* groq */
  `*[_type == "${schemaType}" && secret == $secret && dateTime(_updatedAt) > dateTime(now()) - ${SECRET_TTL}][0]{
    _id,
    _updatedAt,
    secret,
    studioUrl,
  }`
), fetchSharedAccessQuery = (
  /* groq */
  `*[_id == "${schemaIdSingleton}" && _type == "${schemaTypeSingleton}"][0].secret`
), fetchSharedAccessSecretQuery = (
  /* groq */
  `*[_id == "${schemaIdSingleton}" && _type == "${schemaTypeSingleton}" && secret == $secret][0]{
  secret,
  studioUrl,
}`
), deleteExpiredSecretsQuery = (
  /* groq */
  `*[_type == "${schemaType}" && dateTime(_updatedAt) <= dateTime(now()) - ${SECRET_TTL}]`
), vercelProtectionBypassSchemaType = "sanity.vercelProtectionBypass", vercelProtectionBypassSchemaId = `${schemaIdPrefix}.vercel-protection-bypass`, fetchVercelProtectionBypassSecret = (
  /* groq */
  `*[_id == "${vercelProtectionBypassSchemaId}" && _type == "${vercelProtectionBypassSchemaType}"][0].secret`
), tag = "sanity.preview-url-secret", perspectiveCookieName = "sanity-preview-perspective";
export {
  SECRET_TTL,
  apiVersion,
  deleteExpiredSecretsQuery,
  fetchSecretQuery,
  fetchSharedAccessQuery,
  fetchSharedAccessSecretQuery,
  fetchVercelProtectionBypassSecret,
  isDev,
  perspectiveCookieName,
  schemaIdPrefix,
  schemaIdSingleton,
  schemaType,
  schemaTypeSingleton,
  tag,
  urlSearchParamPreviewPathname,
  urlSearchParamPreviewPerspective,
  urlSearchParamPreviewSecret,
  urlSearchParamVercelProtectionBypass,
  urlSearchParamVercelSetBypassCookie,
  vercelProtectionBypassSchemaId,
  vercelProtectionBypassSchemaType
};
//# sourceMappingURL=constants.js.map
